import { useCallback, useState } from 'react';
import { getScrollbarWidth } from 'helpers/utils/getScrollbarWidth';
import useTouchDevice from '../useTouchDevice';

export default function useScrollBlock() {
  const [isBlocked, setIsBlocked] = useState<boolean>(false);
  const { isTouchDevice } = useTouchDevice();

  const blockScrolling = useCallback(() => {
    const scrollbarWidth = getScrollbarWidth();

    const header = document.querySelector('#header-container') as HTMLDivElement;

    if (!isTouchDevice) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      if (header) header.style.paddingRight = `${scrollbarWidth}px`;
    }

    document.body.style.overflowY = 'hidden';
  }, [isTouchDevice]);

  const allowScrolling = useCallback(() => {
    const header = document.querySelector('#header-container') as HTMLDivElement;

    document.body.style.overflowY = 'auto';

    if (!isTouchDevice) {
      document.body.style.paddingRight = '0px';

      if (header) header.style.paddingRight = '0px';
    }
  }, [isTouchDevice]);

  const blockScroll = useCallback(
    (status: boolean) => {
      if (status) blockScrolling();
      else allowScrolling();

      setIsBlocked(status);
    },
    [allowScrolling, blockScrolling],
  );

  return { isBlocked, blockScroll };
}
